module.exports = __webpack_public_path__ + "img/colaborador(6).ab05117e.png";